
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NumberedCardSection extends Vue {
  @Prop({ type: String, default: '' }) readonly title!: string
  @Prop({ type: String, default: '' }) readonly subtitle!: string
  @Prop({ type: String, default: 'transparent' }) readonly backgroundColor!: string
  @Prop({ type: Boolean, default: false }) readonly dark!: boolean
  @Prop({ type: Boolean, default: false }) readonly subtitleFirst!: boolean
}
